import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px;
  font-family: ${theme.font.poppins};
  color: ${theme.colors.white};

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const Text = styled.div`
  max-height: 250px;
  overflow-y: auto;
  padding-right: 15px;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue900};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
  }

  @media (max-width: 768px) {
    max-height: 65vh;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.darkBlue};
  padding: 30px;
  border-radius: ${theme.border.largeRadius};

  @media (max-width: 768px) {
    padding: 15px;
    background-color: ${theme.colors.blue900};
  }
`;

export const Button = styled.button`
  margin-top: 20px;
  max-width: 300px;
  background-color: ${theme.colors.blue400};
  color: ${theme.colors.white};
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  padding: 10px 20px;
  border-radius: ${theme.border.mediumRadius};
  font-family: ${theme.font.poppins};
  align-self: flex-end;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    background-color: ${theme.colors.blue100};
    color: ${theme.colors.darkBlue};
    height: 50px;
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  margin-bottom: 30px;
`;

export const TermsContainer = styled.div`
  height: 50vh;
  overflow-y: auto;
  padding-left: 10px;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue900};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
  }
`;
